var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showButton)?_c('button',{staticClass:"tla-btn tla-btn--link",attrs:{"type":"button","name":_vm.goToStepButtonId,"id":_vm.goToStepButtonId},on:{"click":function($event){return _vm.submitGoToStep()}}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }